import { Breakpoint } from '@altibox/design-system-component-lib';
import React, { FunctionComponent } from 'react';

import { Alert } from 'app/components/alert';
import { Link } from 'app/components/link';
import { config } from 'app/config/config';
import { i18n } from 'app/i18n';
import { I18nUtils } from 'app/utils/i18n-utils';
import { AlertType } from 'app/components/alert/alert-type';

export const CustomerDebtAlert: FunctionComponent = (props) => (
    <Alert
        {...props}
        title={i18n.components.customerDebtAlert.title}
        text={I18nUtils.richMessage(i18n.components.customerDebtAlert.subtitle, {
            linkToCustomerService: (
                <Link variant="paragraph2" maxBreakpoint={Breakpoint.TABLET} href={config.CUSTOMER_SERVICE_URL}>
                    {i18n.components.customerDebtAlert.linkToCustomerService}
                </Link>
            ),
        })}
        type={AlertType.ERROR}
    />
);
